import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { wipeGuestData } from '../../../JS/wipeGuestData';
import { INROOMTAB, globalIV, globalSalt } from '../../../config/constant';
import { AesUtil } from '../../../JS/AesUtil';
import { popupOpenClose, setLoadingMass, setPreloadScreen, setQueuedCheckInSuccess, setRegPage, validateGuestdetail } from '../../../action/action';
import { fetchSessionToken } from '../../../JS/fetchSessionToken';
import { setGoHome, setLoader } from '../../action/homeAction';
import doorKeySvg from "./assets/ico_generic_doorkey.svg";
import { sendAnalytics } from '../../../action/homeAction';
import { getDefaultAnalyticsLabel } from '../../JS/utility';


const QueuedBookingSuccess = (props) => {

    const { t } = props
    const [loginProgress, setLoginProgress] = React.useState(false);
    const [loginState, setLoginState] = React.useState(false);
    let aesUtil = new AesUtil(128, 1000);
    let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
    const checkInguestInfo = localStorage.getItem("Set_Current_Logged_In_Guest_Details") && JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"));

    const handleLoginCallback = (status, room, locationId, errorMsg) => {
        setLoginProgress(false);
        setLoginState(status);

        if(status){
            props.setLoadingMass(true);
            props.setPreloadScreen(true);
            localStorage.setItem("room", room);
            localStorage.setItem('VerifiedUser', true);
            sessionStorage.setItem("redirectInfo", JSON.stringify(props.redirectInfo))
            localStorage.setItem("queuedLoggedIn", true);


            props.sendAnalytics(
                null, // as no guesdetails in logout state 
                "Auto Check-in", 
                "Auto Login SUCCESS", 
                {...label, "element": "popup"},
                0, 
                false // guest is not logged in
            );


            setTimeout(() => {
                window.location.reload();
            }, 500);
        } else {
            props.setLoader(false);
            localStorage.removeItem("room");
            props.setQueuedCheckInSuccess(false);
            props.popupOpenClose(true, t('check_in.queued_checkin_autoLogin_fail'));

            props.sendAnalytics(
                null, // as no guesdetails in logout state 
                "Auto Check-in", 
                "Auto Login FAILED", 
                {...label, "element": "popup", "errorMessage": errorMsg  },
                0, 
                false // guest is not logged in
            );
        }
    }

    const handleSuccessCheckIn = () => {

        props.setLoader(true, "Connecting you to your room..." , false)
        setLoginProgress(true);

        let encodData = fetchSessionToken();

        let preCheckedInGuestInfo
        if(localStorage.getItem("X_CHECKIN_PQ_DATA")){
            preCheckedInGuestInfo = localStorage.getItem("X_CHECKIN_PQ_DATA") && JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",localStorage.getItem("X_CHECKIN_PQ_DATA")))
        } else{
            preCheckedInGuestInfo = localStorage.getItem("loginAuthToken") && JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",localStorage.getItem("loginAuthToken")))
            localStorage.removeItem("loginAuthToken");
        }
        
        props.validateGuestdetail(encodData, preCheckedInGuestInfo.lastName, props.queuedCheckInRoomNumber || localStorage.getItem("room"),handleLoginCallback, preCheckedInGuestInfo.confirmationNumber);


        props.sendAnalytics(
            null, // as no guesdetails in logout state 
            "Auto Check-in", 
            "Auto Login Attempted", 
            {...label, "element": "popup" },
            0, 
            false // guest is not logged in
        );
    }

    const handleUserClick = () => {
        // wipeGuestData({inRoomTab: INROOMTAB, eventName: "QUEUED_GUEST_CHECKED_IN"})
        localStorage.removeItem("queuedLoggedIn")
        props.setQueuedCheckInSuccess(false);
    }

    React.useEffect(() => {
        props.setGoHome(true);
        props.setRegPage(false);

        if(!localStorage.getItem("queuedLoggedIn")){
            handleSuccessCheckIn();
        }
    },[])

    return localStorage.getItem("queuedLoggedIn") && (
        <>
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title w-65">
                                    <h2 style={{ color: "#000 !important;" }}>{t('check_in.queued_checkin_success_heading').replace("#GUESTNAME", checkInguestInfo[0].guestName).replace("FIRSTNAME",checkInguestInfo[0].guestProfile.firstName).replace("#LASTNAME", checkInguestInfo[0].guestProfile.lastName) }</h2>
                                    <p>{t('check_in.queued_checkin_success_message').replace("#ROOMNUMBER", localStorage.getItem("room"))}</p>
                                    {localStorage.getItem("isDoorKeyInLayout") == "true" ? <p>{t('check_in.digital_key_msg1')} <img src={doorKeySvg} style={{width:"1.3rem", height:"1rem"}} alt='door_key' />{t('check_in.digital_key_msg2')}</p> /* Hide when hotel locks support virtual door key */: <p>{t('check_in.key_from_desk')}</p>}
                                </div>
                                <div class="overlay-header-icon w-35">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                            </div>
                        </div>
                        <div class="overlay-controls">
                            <button onClick={handleUserClick} class="button w-100">{loginProgress && <div class="loader-ring">
                                <img src="layout_2/assests/loader.png" />
                            </div>} Ok</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        redirectInfo: state.store2.redirectInfo,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        queuedCheckInRoomNumber: state.store2.queuedCheckInRoomNumber,
    }
}


export default connect(mapStateToProps, {setLoadingMass, 
    setPreloadScreen, 
    validateGuestdetail,
    popupOpenClose,
    setLoader,
    setQueuedCheckInSuccess,
    setGoHome,
    sendAnalytics,
    setRegPage
})(withTranslation('translations')(QueuedBookingSuccess));